import { render } from "./UniqueView.vue?vue&type=template&id=39f41872"
import script from "./UniqueView.vue?vue&type=script&lang=js"
export * from "./UniqueView.vue?vue&type=script&lang=js"

import "./UniqueView.vue?vue&type=style&index=0&id=39f41872&lang=css"

import exportComponent from "/Users/peterdevos/Apps/sthree_grijper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__